/**
 * @author binhld
 * @version 25/11/2022
 */
 export const constRouter = {
    organization_info: '/user/organization-info',
    organization_branch_all: '/user/organization-branch',
    organization_branch_add: '/user/add-organization-branch',
    organization_branch_edit: '/user/edit-organization-branch',
    employee_all: '/user/manage-employee',
    employee_add: '/user/add-employee',
    employee_edit: '/user/edit-employee',
    leave_all: '/user/manage-leave',
    leave_edit: '/user/edit-leave',
    leave_add: '/user/assign-leave',
    permission_all: '/user/manage-permission',
    permission_add: '/user/add-permission',
    permission_edit: '/user/edit-permission',
    positinon_all: '/user/manage-position',
    positinon_add: '/user/add-position',
    positinon_edit: '/user/edit-position',
    customer_all: '/user/customer',
    customer_add: '/user/add-customer',
    customer_edit: '/user/edit-customer',
    customer_in_out_history: '/user/in-out-history-customer',
    multipurpose_all: '/user/manage-multipurpose-room',
    meeting_room_all: '/user/manage-meeting-room',
    meeting_room_add: '/user/add-meeting-room',
    meeting_room_edit: '/user/edit-meeting-room',
    meeting_schedule_all: '/user/meeting-schedule',
    meeting_schedule_create: '/user/book-a-meeting',
    camera_stream: '/user/stream-camera',
    camera_recording: '/user/stream-camera',
    camera_playback: '/user/play-back',
    camera_all: '/user/manage-camera-layout',
    camera_group_all: '/user/manage-camera-group',
    camera_group_add: '/user/add-camera-group',
    camera_group_edit: '/user/edit-camera-group',
    camera_event_all: '/user/manage-event',
    hardware_device_all: '/user/manage-hardware-devices',
    hardware_device_update: '/user/edit-hardware-device',
    face_recognition_all: '/user/face-recognition',
    face_recognition_add: '/user/add-face-recognition',
    face_recognition_edit: '/user/edit-face-recognition',
    ai_restricted_all: '/user/ai-restrictedarea',
    ai_restricted_create: '/user/ai-restrictedarea-create',
    ai_restricted_update: '/user/ai-restrictedarea-update',
    intrusion_detection_all: '/user/ai-restrictedarea-history',
    wifi_all: '/user/manage-wifi',
    wifi_add: '/user/add-wifi',
    wifi_edit: '/user/edit-wifi',
    qr_code_all: '/user/manage-qr-code',
    qr_code_add: '/user/add-qr-code',
    qr_code_edit: '/user/edit-qr-code',
    work_shift_branch_add: '/user/add-work-shift',
    work_shift_branch_edit: '/user/edit-work-shift',
    work_shift_by_day_all: '/user/manage-work-shift-by-day',
    over_time_all: '/user/over-time-manager',
    over_time_add: '/user/over-time',
    over_time_edit: '/user/over-time',
    time_keeping_all: '/user/time-keeping',
    time_keeping_details: '/user/time-keeping-detail',
    update_in_out_all: '/user/update-in-out',
    update_in_out_update: '/user/update-in-out-by-id',
    update_in_out_add: '/user/update-in-out-by-id',
    in_out_history_all: '/user/in-out-history',
    policy_all: '/user/manage-policy',
    policy_add: '/user/manage-policy-info',
    holiday_all: '/user/manage-holiday',
    holiday_add: '/user/manage-holiday-info',
    holiday_update: '/user/manage-holiday-info',
    news_all: '/user/manage-news',
    news_add: '/user/add-news',
    news_edit: '/user/edit-news',
    notification_all: '/user/manage-notification',
    notification_add: '/user/add-notification',
    device_all: '/user/manage-device',
    device_add: '/user/add-device',
    device_update: '/user/edit-device',
    device_assign: '/user/assign-device',
    device_revoke: '/user/manage-device',
    assign_device_history: '/user/assign-device-history',
    equipment_all: '/user/manage-equipment',
    equipment_update: '/user/edit-equipment',
    equipment_add: '/user/add-equipment',
    equipment_assign: '/user/assign-equipment',
    assign_equipment_history_all: '/user/assign-equipment-history',
    dashboard_employee_early: '/dashboard',
    dashboard_employee_late: '/dashboard',
    dashboard_total_employee: '/dashboard',
    dashboard_total_employee_checkin: '/dashboard',
    dashboard_total_employee_checkin_late: '/dashboard',
    dashboard_total_employee_not_checkin: '/dashboard',
    dashboard_employee_checkin_day_by_day: '/dashboard',
    dashboard_leave: '/dashboard',
    dashboard_total_employee_checkin_location: '/dashboard',
    menu_manage_employee: '/user/menu-manager-employee', // Menu nhan vien
    menu_customer: '/user/menu-customer', // Menu khach hang
    menu_resource: '/user/menu-resource', // Menu tai nguyen
    menu_camera: '/user/menu-camera', //Menu Camera
    menu_manage_hardware_devices: '/user/menu-manage-hardware-devices', // Menu thiet bi cham cong
    menu_manage_event: '/user/menu-ai', // Menu AI
    menu_manage_wifi: '/user/menu-manage-wifi', // Menu cham cong
    menu_policy: '/user/menu-policy', // Menu chinh sach
    menu_internal_communications: '/user/menu-internal-communications', // Menu truyen thong noi bo
    menu_asset: '/user/menu-asset', // Menu tai san
    menu_items: '/user/menu-item', // Menu vat dung,
    menu_schedule: '/user/menu-schedule', // Menu thoi khoa bieu
    menu_attendence: '/user/menu-attendance', // Menu diem danh
    class_all: '/user/manage-class',
    class_add: '/user/class-info',
    class_edit: '/user/class-edit',
    student_all: '/user/student',
    student_add: '/user/student-infomation',
    student_edit: '/user/student-infomation',
    student_in_out_history: '/user/student-in-out-history',
    menu_work_shift_school_all: '/user/work-shift-school',
    work_shift_school_all: '/user/work-shift-school',
    work_shift_school_add: '/user/work-shift-school',
    work_shift_school_update: '/user/work-shift-school',
    work_shift_school_delete: '/user/work-shift-school',
    menu_schedule_staff: '/user/schedule-staff',
    menu_dashbord: '/user/menu-dashboard',
    schedule_all: '/user/schedule',
}
export const constAPI = {
    organization_info: 'PRIVILEGE_ORGANIZATION_INFO',
    organization_update: 'PRIVILEGE_ORGANIZATION_EDIT',
    organization_branch_all: 'PRIVILEGE_ORGANIZATION_BRANCH_SCHOOL_ALL',
    organization_branch_add: 'PRIVILEGE_ORGANIZATION_BRANCH_SCHOOL_ADD',
    organization_branch_edit: 'PRIVILEGE_ORGANIZATION_BRANCH_SCHOOL_UPDATE',
    organization_branch_delete: 'PRIVILEGE_ORGANIZATION_BRANCH_SCHOOL_DELETE',
    employee_all: 'PRIVILEGE_EMPLOYEE_SCHOOL_ALL',
    employee_add: 'PRIVILEGE_EMPLOYEE_SCHOOL_ADD',
    employee_edit: 'PRIVILEGE_EMPLOYEE_SCHOOL_UPDATE',
    employee_delete: 'PRIVILEGE_EMPLOYEE_SCHOOL_DELETE',
    leave_all: 'PRIVILEGE_LEAVE_ALL',
    leave_edit: 'PRIVILEGE_LEAVE_ASSIGN',
    leave_add: 'PRIVILEGE_LEAVE_ADD',
    multipurpose_all: 'PRIVILEGE_MULTIPURPOSE_ALL',
    permission_delete: 'PRIVILEGE_PERMISSION_DELETE',
    permission_all: 'PRIVILEGE_PERMISSION_ALL',
    permission_add: 'PRIVILEGE_PERMISSION_ADD',
    permission_edit: 'PRIVILEGE_PERMISSION_EDIT',
    positinon_delete: 'PRIVILEGE_POSITION_DELETE',
    positinon_all: 'PRIVILEGE_POSITION_ALL',
    positinon_add: 'PRIVILEGE_POSITION_ADD',
    positinon_edit: 'PRIVILEGE_POSITION_EDIT',
    customer_delete: 'PRIVILEGE_CUSTOMER_DELETE',
    customer_all: 'PRIVILEGE_CUSTOMER_ALL',
    customer_add: 'PRIVILEGE_CUSTOMER_ADD',
    customer_edit: 'PRIVILEGE_CUSTOMER_EDIT',
    customer_in_out_history: 'PRIVILEGE_CUSTOMER_IN_OUT_HISTORY_ALL',
    meeting_room_delete: 'PRIVILEGE_MEETING_ROOM_DELETE',
    meeting_room_all: 'PRIVILEGE_MEETING_ROOM_ALL',
    meeting_room_add: 'PRIVILEGE_MEETING_ROOM_ADD',
    meeting_room_edit: 'PRIVILEGE_MEETING_ROOM_EDIT',
    meeting_schedule_delete: 'PRIVILEGE_MEETING_SCHEDULE_DELETE',
    meeting_schedule_all: 'PRIVILEGE_MEETING_SCHEDULE_ALL',
    meeting_schedule_create: 'PRIVILEGE_MEETING_SCHEDULE_CREATE',
    camera_stream: 'PRIVILEGE_CAMERA_STREAM',
    camera_recording: 'PRIVILEGE_CAMERA_IS_RECORDING',
    camera_playback: 'PRIVILEGE_CAMERA_PLAYBACK',
    camera_all: 'PRIVILEGE_CAMERA_ALL',
    camera_extract_image: 'PRIVILEGE_CAMERA_EXTRACT_IMAGE',
    camera_group_all: 'PRIVILEGE_CAMERA_GROUP_ALL',
    camera_group_add: 'PRIVILEGE_CAMERA_GROUP_ADD',
    camera_group_edit: 'PRIVILEGE_CAMERA_GROUP_EDIT',
    camera_group_delete: 'PRIVILEGE_CAMERA_GROUP_DELETE',
    camera_event_all: 'PRIVILEGE_CAMERA_EVENT_ALL',
    hardware_device_delete: 'PRIVILEGE_HARDWARE_DEVICE_DELETE',
    hardware_device_all: 'PRIVILEGE_HARDWARE_DEVICE_ALL',
    hardware_device_update: 'PRIVILEGE_HARDWARE_DEVICE_UPDATE',
    face_recognition_delete: 'PRIVILEGE_FACE_RECOGNITION_DELETE',
    face_recognition_all: 'PRIVILEGE_FACE_RECOGNITION_ALL',
    face_recognition_add: 'PRIVILEGE_FACE_RECOGNITION_ADD',
    face_recognition_edit: 'PRIVILEGE_FACE_RECOGNITION_UPDATE',
    ai_restricted_delete: 'PRIVILEGE_AI_RESTRICTED_DELETE',
    ai_restricted_all: 'PRIVILEGE_AI_RESTRICTED_ALL',
    ai_restricted_create: 'PRIVILEGE_AI_RESTRICTED_CREATE',
    ai_restricted_update: 'PRIVILEGE_AI_RESTRICTED_UPDATE',
    intrusion_detection_all: 'PRIVILEGE_INTRUSION_DETECTION_ALL',
    wifi_delete: 'PRIVILEGE_MANAGE_WIFI_DELETE',
    wifi_all: 'PRIVILEGE_MANAGE_WIFI_ALL',
    wifi_add: 'PRIVILEGE_MANAGE_WIFI_ADD',
    wifi_edit: 'PRIVILEGE_MANAGE_WIFI_UPDATE',
    qr_code_delete: 'PRIVILEGE_MANAGE_QR_CODE_DELETE',
    qr_code_all: 'PRIVILEGE_MANAGE_QR_CODE_ALL',
    qr_code_add:'PRIVILEGE_MANAGE_QR_CODE_ADD',
    qr_code_edit: 'PRIVILEGE_MANAGE_QR_CODE_UPDATE',
    work_shift_branch_delete: 'PRIVILEGE_WORK_SHIFT_BRANCH_DELETE',
    work_shift_branch_add: 'PRIVILEGE_WORK_SHIFT_BRANCH_ADD',
    work_shift_branch_edit: 'PRIVILEGE_WORK_SHIFT_BRANCH_UPDATE',
    work_shift_by_day_all: 'PRIVILEGE_WORK_SHIFT_BY_DAY_ALL',
    over_time_all: 'PRIVILEGE_MANAGE_OVER_TIME_ALL',
    over_time_add: 'PRIVILEGE_MANAGE_OVER_TIME_ADD',
    over_time_edit: 'PRIVILEGE_MANAGE_OVER_TIME_UPDATE',
    over_time_accept: 'PRIVILEGE_MANAGE_OVER_TIME_ACCEPT',
    over_time_reject: 'PRIVILEGE_MANAGE_OVER_TIME_REJECT',
    time_keeping_all: 'PRIVILEGE_TIME_KEEPING_ALL',
    update_in_out_all: 'PRIVILEGE_UPDATE_IN_OUT_ALL',
    update_in_out_update: 'PRIVILEGE_UPDATE_IN_OUT_UPDATE',
    update_in_out_add: 'PRIVILEGE_UPDATE_IN_OUT_ADD',
    in_out_history_all: 'PRIVILEGE_IN_OUT_HISTORY_ALL',
    in_out_history_add: 'PRIVILEGE_IN_OUT_HISTORY_ADD', // Tao bao cao
    policy_all: 'PRIVILEGE_MANAGE_POLICY_ALL',
    policy_add: 'PRIVILEGE_MANAGE_POLICY_ADD',
    holiday_delete: 'PRIVILEGE_MANAGE_HOLIDAY_DELETE',
    holiday_all: 'PRIVILEGE_MANAGE_HOLIDAY_ALL',
    holiday_add: 'PRIVILEGE_MANAGE_HOLIDAY_ADD',
    holiday_update: 'PRIVILEGE_MANAGE_HOLIDAY_UPDATE',
    news_delete: 'PRIVILEGE_MANAGE_NEWS_DELETE',
    news_all: 'PRIVILEGE_MANAGE_NEWS_ALL',
    news_add: 'PRIVILEGE_MANAGE_NEWS_ADD',
    news_edit: 'PRIVILEGE_MANAGE_NEWS_UPDATE',
    notification_delete: 'PRIVILEGE_MANAGE_NOTIFICATION_DELETE',
    notification_add: 'PRIVILEGE_MANAGE_NOTIFICATION_ADD',
    notification_all: 'PRIVILEGE_MANAGE_NOTIFICATION_ALL',
    device_delete: 'PRIVILEGE_MANAGE_DEVICE_DELETE',
    device_add: 'PRIVILEGE_MANAGE_DEVICE_ADD',
    device_all: 'PRIVILEGE_MANAGE_DEVICE_ALL',
    device_update: 'PRIVILEGE_MANAGE_DEVICE_UPDATE',
    device_assign: 'PRIVILEGE_SCHOOL_DEVICE_ASSIGN',
    device_revoke: 'PRIVILEGE_SCHOOL_DEVICE_REEVOKE',
    assign_device_history: 'PRIVILEGE_ASSIGN_DEVICE_HISTORY_ALL',
    equipment_delete: 'PRIVILEGE_MANAGE_EQUIPMENT_DELETE',
    equipment_add: 'PRIVILEGE_MANAGE_EQUIPMENT_ADD',
    equipment_all: 'PRIVILEGE_MANAGE_EQUIPMENT_ALL',
    equipment_update: 'PRIVILEGE_MANAGE_EQUIPMENT_UPDATE',
    equipment_assign: 'PRIVILEGE_SCHOOL_MANAGE_EQUIPMENT_ASSIGN',
    assign_equipment_history_all: 'PRIVILEGE_ASSIGN_EQUIPMENT_HISTORY_ALL',
    dashboard_employee_early: 'PRIVILEGE_DASHBOARD_EMPLOYEE_EARLY',
    dashboard_employee_late: 'PRIVILEGE_DASHBOARD_EMPLOYEE_LATE',
    dashboard_total_employee: 'PRIVILEGE_DASHBOARD_TOTAL_EMPLOYEE',
    dashboard_total_employee_checkin: 'PRIVILEGE_DASHBOARD_TOTAL_EMPLOYEE_CHECKIN',
    dashboard_total_employee_checkin_late: 'PRIVILEGE_DASHBOARD_TOTAL_EMPLOYEE_CHECKIN_LATE',
    dashboard_total_employee_not_checkin: 'PRIVILEGE_DASHBOARD_TOTAL_EMPLOYEE_NOT_CHECKIN',
    dashboard_employee_checkin_day_by_day: 'PRIVILEGE_DASHBOARD_EMPLOYEE_CHECKIN_DAY_BY_DAY',
    dashboard_leave: 'PRIVILEGE_DASHBOARD_LEAVE',
    dashboard_total_employee_checkin_location: 'PRIVILEGE_DASHBOARD_TOTAL_EMPLOYEE_CHECKIN_LOCATION',
    department_employee_all: 'PRIVILEGE_DEPARTMENT_EMPLOYEE_ALL',
    department_employee_time_keeping: 'PRIVILEGE_DEPARTMENT_EMPLOYEE_TIME_KEEPING',
    department_employee_dayoff_view: 'PRIVILEGE_DEPARTMENT_EMPLOYEE_DAYOFF_VIEW',
    department_employee_dayoff_update: 'PRIVILEGE_DEPARTMENT_EMPLOYEE_DAYOFF_UPDATE',
    class_all: 'PRIVILEGE_MANAGE_CLASS_ALL',
    class_add: 'PRIVILEGE_MANAGE_CLASS_ADD',
    class_edit: 'PRIVILEGE_MANAGE_CLASS_UPDATE',
    class_delete: 'PRIVILEGE_MANAGE_CLASS_DELETE',
    student_all: 'PRIVILEGE_MANAGE_STUDENT_ALL',
    student_add: 'PRIVILEGE_MANAGE_STUDENT_ADD',
    student_edit: 'PRIVILEGE_MANAGE_STUDENT_UPDATE',
    student_delete: 'PRIVILEGE_MANAGE_STUDENT_DELETE',
    attendence: 'PRIVILEGE_MANAGE_ATTENDANCE_ALL',
    attendance_accept: 'PRIVILEGE_MANAGE_ATTENDANCE_ACCEPT',
    student_in_out_history: 'PRIVILEGE_SCHOOL_STUDENT_IN_OUT',
    work_shift_school_all: 'PRIVILEGE_TEACHING_SCHEDULE_ALL',
    work_shift_by_day_add: 'PRIVILEGE_TEACHING_SCHEDULE_ADD',
    work_shift_school_update: 'PRIVILEGE_TEACHING_SCHEDULE_UPDATE',
    work_shift_school_delete: 'PRIVILEGE_TEACHING_SCHEDULE_DELETE',
    schedule_all: 'PRIVILEGE_SCHOOL_SCHEDULE_ALL',
    schedule_add: 'PRIVILEGE_SCHOOL_SCHEDULE_ADD',
    schedule_update: 'PRIVILEGE_SCHOOL_SCHEDULE_UPDATE',
    schedule_delete: 'PRIVILEGE_SCHOOL_SCHEDULE_DELETE',
    time_keeping_accept: 'PRIVILEGE_SCHOOL_STAFF_TIME_KEEPING_UPDATE',
    staff_schedule_all: 'PRIVILEGE_STAFF_TEACHING_SCHEDULE_ALL',
    staff_schedule_add: 'PRIVILEGE_STAFF_TEACHING_SCHEDULE_ADD',
    staff_schedule_update: 'PRIVILEGE_STAFF_TEACHING_SCHEDULE_UPDATE',
    staff_schedule_delete: 'PRIVILEGE_STAFF_TEACHING_SCHEDULE_DELETE',
    teaching_schedule_all: 'PRIVILEGE_TEACHING_SCHEDULE_ALL',
    teaching_schedule_add: 'PRIVILEGE_TEACHING_SCHEDULE_ADD',
    teaching_schedule_update: 'PRIVILEGE_TEACHING_SCHEDULE_UPDATE',
    teaching_schedule_delete: 'PRIVILEGE_TEACHING_SCHEDULE_DELETE',
    schedule_staff_all: 'PRIVILEGE_SCHOOL_SCHEDULE_STAFF_ALL',
    schedule_staff_add: 'PRIVILEGE_SCHOOL_SCHEDULE_STAFF_ADD',
    schedule_staff_update: 'PRIVILEGE_SCHOOL_SCHEDULE_STAFF_UPDATE',
    schedule_staff_delete: 'PRIVILEGE_SCHOOL_SCHEDULE_STAFF_DELETE',
    menu_dashbord: 'PRIVILEGE_SCHOOL_DASHBOARD',
    export_report:'PRIVILEGE_SCHOOL_ACCOUNTANT',
}

